module.exports = __webpack_public_path__ + "static/img/nochoose.bc7df51.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/nochoose.png
// module id = Ui5c
// module chunks = 1